// extracted by mini-css-extract-plugin
export var oKeyVisual = "keyVisual-module--o-keyVisual--2Ay4N";
export var oKeyVisual__outer = "keyVisual-module--o-keyVisual__outer--2M88V";
export var pleaseScroll = "keyVisual-module--pleaseScroll--1Dzmf";
export var line = "keyVisual-module--line--3wvRH";
export var arrow = "keyVisual-module--arrow--3VCMr";
export var arrowNarrow = "keyVisual-module--arrowNarrow--1N4za";
export var lContent__inner = "keyVisual-module--l-content__inner--1XJgs";
export var oKeyVisual__message = "keyVisual-module--o-keyVisual__message--1mnLF";
export var oKeyVisual__image = "keyVisual-module--o-keyVisual__image--3YnvE";
export var oButton = "keyVisual-module--o-button--14pjQ";
export var visible = "keyVisual-module--visible--1bjEH";
export var yellowRectangle = "keyVisual-module--yellowRectangle--3Bd2C";
export var yellowRectangleNarrow = "keyVisual-module--yellowRectangleNarrow--2ml4c";
export var turquoiseRectangle = "keyVisual-module--turquoiseRectangle--1-4j-";
export var texts = "keyVisual-module--texts--1Gr_q";
export var textsNarrow = "keyVisual-module--textsNarrow--3S84r";
export var keyVisual = "keyVisual-module--keyVisual--3roQm";
export var standby = "keyVisual-module--standby--2X1yT";